export const formatDate = (date: string, format?: any) => {
  if (!date) return "";

  try {
    const [year, month, day] = date.split("-").map(Number);
    // Create date in UTC, so it's not affected by local timezones
    const utcDate = new Date(Date.UTC(year, month - 1, day));

    const formatter = new Intl.DateTimeFormat("en-GB", {
      ...format,
      timeZone: "Europe/London", // Force UK timezone
    });

    return formatter.format(utcDate).replace(/\//g, ".");
  } catch (e) {
    console.error("Date formatting error:", e);
    return "";
  }
};

export const dateWeekday = (date: string) => {
  if (!date) return "";

  try {
    const [year, month, day] = date.split("-").map(Number);
    const utcDate = new Date(Date.UTC(year, month - 1, day));

    return new Intl.DateTimeFormat("en-GB", {
      weekday: "long",
      timeZone: "Europe/London",
    }).format(utcDate);
  } catch (e) {
    console.error("Error getting weekday:", e);
    return "";
  }
};


export const dateYear = (date: string, defaultToThisYear: boolean = true) => {
  const getYearInUK = (dateObj: Date) => {
    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      timeZone: "Europe/London",
    }).format(dateObj);
  };

  if (date) {
    try {
      const [year, month, day] = date.split("-").map(Number);
      const utcDate = new Date(Date.UTC(year, month - 1, day));
      return getYearInUK(utcDate);
    } catch (e) {
    }
  }

  if (!defaultToThisYear) return null;

  const now = new Date();
  return getYearInUK(now);
};
